'use strict';

/* Controllers */
(function () {
    angular.module('pt.controllers')
      .controller('termsOfUseCtrl', ['$scope', '$stateParams', '$window', '$state', '$location', function ($scope, $stateParams, $window, $state, $location) {
          
      }]);
})();
